import { rules as usrules } from "../validate/city/US.js";
import { rules as carules } from "../validate/city/CA.js";
import storeage from "../../utils/storeage";

export const cityRules = storeage.getSystemGeneralInfo()?.appCountry == "US" ? usrules : carules;
